import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { useDocHubTipsTags } from "@/hooks/useDocHubTipsTags";

interface TipsTagSelectorProps {
  brandId: string;
  selectedTagIds: string[];
  onTagsChange: (tagIds: string[]) => void;
}

export function TipsTagSelector({
  brandId,
  selectedTagIds,
  onTagsChange,
}: TipsTagSelectorProps) {
  const { tags } = useDocHubTipsTags(brandId);

  const toggleTag = (tagId: string) => {
    if (selectedTagIds.includes(tagId)) {
      onTagsChange(selectedTagIds.filter(id => id !== tagId));
    } else {
      onTagsChange([...selectedTagIds, tagId]);
    }
  };

  if (tags.length === 0) {
    return (
      <div>
        <Label>Tags</Label>
        <p className="text-sm text-muted-foreground mt-2">No tags available. Create tags first using "Manage Tags".</p>
      </div>
    );
  }

  return (
    <div>
      <Label>Tags (Optional)</Label>
      <div className="flex flex-wrap gap-2 mt-2">
        {tags.map((tag) => (
          <Badge
            key={tag.id}
            variant={selectedTagIds.includes(tag.id) ? "default" : "outline"}
            className="cursor-pointer"
            style={selectedTagIds.includes(tag.id) ? { backgroundColor: tag.color } : undefined}
            onClick={() => toggleTag(tag.id)}
          >
            {tag.name}
          </Badge>
        ))}
      </div>
      {selectedTagIds.length > 0 && (
        <p className="text-xs text-muted-foreground mt-2">{selectedTagIds.length} tag(s) selected</p>
      )}
    </div>
  );
}
